import OrdersHeader from "./OrdersHeader";
import OrdersTable from "./OrdersTable";
import Layout from "../../../Layout";

/**
 * The orders page.
 */
function Orders() {
  return (
    <Layout>
      <div className="w-full h-full flex flex-col px-3 lg:px-16 ">
        <OrdersHeader />
        <OrdersTable />
      </div>
    </Layout>
  );
}

export default Orders;
